var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
var HistoryNotificationTranslation = /** @class */ (function (_super) {
    __extends(HistoryNotificationTranslation, _super);
    function HistoryNotificationTranslation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.templateConfigs = {
            new_talent_1: {
                path: 'notifications.aggregates.new_talent_1',
                tag: 'p',
                name1: true,
                pipeline: true,
            },
            new_talent_2: {
                path: 'notifications.aggregates.new_talent_2',
                tag: 'p',
                name1: true,
                name2: true,
                pipeline: true,
            },
            new_talent_many: {
                path: 'notifications.aggregates.new_talent_many',
                tag: 'p',
                name1: true,
                name2: true,
                count: true,
                pipeline: true,
            },
            talent_moved_1: {
                path: 'notifications.aggregates.talent_moved_1',
                tag: 'p',
                name1: true,
                fromStage: true,
                toStage: true,
                pipeline: true,
            },
            talent_moved_2: {
                path: 'notifications.aggregates.talent_moved_2',
                tag: 'p',
                name1: true,
                name2: true,
                fromStage: true,
                toStage: true,
                pipeline: true,
            },
            talent_moved_many: {
                path: 'notifications.aggregates.talent_moved_many',
                tag: 'p',
                name1: true,
                name2: true,
                fromStage: true,
                toStage: true,
                count: true,
                pipeline: true,
            },
            inbound_email_1: {
                path: 'notifications.aggregates.inbound_email_1',
                tag: 'p',
                name1: true,
                pipeline: true,
            },
            inbound_email_2: {
                path: 'notifications.aggregates.inbound_email_2',
                tag: 'p',
                name1: true,
                name2: true,
                pipeline: true,
            },
            inbound_email_many: {
                path: 'notifications.aggregates.inbound_email_many',
                tag: 'p',
                name1: true,
                name2: true,
                count: true,
                pipeline: true,
            },
            talent_comment_1: {
                path: 'notifications.aggregates.talent_comment_1',
                tag: 'p',
                name1: true,
            },
            talent_comment_2: {
                path: 'notifications.aggregates.talent_comment_2',
                tag: 'p',
                name1: true,
                name2: true,
            },
            talent_comment_many: {
                path: 'notifications.aggregates.talent_comment_many',
                tag: 'p',
                name1: true,
                name2: true,
                count: true,
            },
        };
        return _this;
    }
    Object.defineProperty(HistoryNotificationTranslation.prototype, "templateConfig", {
        get: function () {
            return this.templateConfigs[this.notificationKey];
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ required: true }),
        __metadata("design:type", Object)
    ], HistoryNotificationTranslation.prototype, "dataText", void 0);
    __decorate([
        Prop({ required: true }),
        __metadata("design:type", String)
    ], HistoryNotificationTranslation.prototype, "notificationKey", void 0);
    HistoryNotificationTranslation = __decorate([
        Component({})
    ], HistoryNotificationTranslation);
    return HistoryNotificationTranslation;
}(Vue));
export default HistoryNotificationTranslation;
